import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import { paystoneGiftCardOperation } from 'actions/EntityActions';
import { formInput } from 'actions/FormActions';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
class PaystoneGiftCardCheckBalance extends Component {
    constructor(props, context) {
        super(props, context);
    }

    checkBalance = () => {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            CardNumber: p.cardNumber,
            PayStoneOperations: LOOKUP.PayStoneGiftCardOperationType.Balance,
            WAN: p.cashflow.employee.id,
            WSN: p.cashflow.deviceId
        };
        this.props.paystoneGiftCardOperation(model);
    }
    
    render() {
        const { t } = this.props;
        let p = this.props;
        return (
            <DialogInput
                title={<DialogHeaderWithClose text={t('pos.giftCard.checkBalance.label')} classicClass="posDialogClassic" handleClose={() => this.props.onCancel()} />}
                actions={[
                    <Button
                        key={2}
                        className="pull-right space btnNewBrandPOS"
                        name="buttonRefundDialogConfirm"
                        label={t('common.confirm')}
                        primary={true}
                        onTouchTap={() => this.checkBalance()} />]}
                modal={true}
                style={{ zIndex: '980' }}
                open={this.props.show}
                autoScrollBodyContent={true}>
                <div>
                    <h4 className="purpleText">{t('pos.paystoneGiftcard.checkBalance.fillUpInfo')}</h4>
                    <div className="row">
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}CardNumber`}
                                fullWidth={true}
                                label={t('common.cardNum')}
                                floatingLabelText={t('common.cardNum')}
                                hintText={t('common.cardNum')} />
                        </div>
                    </div>
                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        cardNumber: state.form[`PaystoneGiftCardCheckBalanceCardNumber`] || '',
        store: state.common.store,
        cashflow: state.entity.cashFlow
    };
}

function mapDispatchToProps(dispatch) {
    return {
        paystoneGiftCardOperation: (model) => dispatch(paystoneGiftCardOperation(model)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PaystoneGiftCardCheckBalance));